/* Core & libraries */
import React from "react";
import injectSheet from 'react-jss';
import * as Sentry from '@sentry/react';

/* Helpers, constants, custom methods, internal libraries */
import { LocaleProvider } from "./contexts/localeContext";
import { NotificationProvider } from "./contexts/notificationContext";
import { UserProvider } from "./contexts/userContext";
import { SpinnersProvider } from "./contexts/spinnersContext";
import { GlobalProvider } from "./contexts/globalContext";
import { APP_ENVIRONMENT, RELEASE_VERSION, SENTRY_DSN, SENTRY_ENABLED } from "./constants/appConstants";

/* Components */
import MainWrapper from "./components/mainWrapper";
import Router from "./components/router";

/* Styles */
import styles from "./styles.js";

Sentry.init({
  release: RELEASE_VERSION,
  dsn: SENTRY_DSN,
  environment: APP_ENVIRONMENT,
  enabled: SENTRY_ENABLED,
  sampleRate: 0.5,        // Capture 50% of errors
  tracesSampler: ({ name, attributes, inheritOrSampleWith }) => {
    // These are important - take a big sample
    if (name.includes("app/static/js")) {
      return 1;
    }
    // These are less important or happen much more frequently - only take 1%
    if (/^dcf-?smartweb-?service.*/.test(name)) {
      return 0.01;
    }
    // Otherwise, inherit the sample sampling decision of the incoming trace, or use a fallback sampling rate.
    return inheritOrSampleWith(0.5);
  },

  integrations: [
    Sentry.browserTracingIntegration({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      //tracePropagationTargets: ["localhost", /^https:\/\/aadev-app01.nutravel\.com\/app/],
    }),
    Sentry.replayIntegration(),
  ],
});

const App = () => {

  return (
    <LocaleProvider>
      <SpinnersProvider>
        <UserProvider>
          <MainWrapper>
            <NotificationProvider>
              <GlobalProvider>
                <Router/>
              </GlobalProvider>
            </NotificationProvider>
          </MainWrapper>
        </UserProvider>
      </SpinnersProvider>
    </LocaleProvider>
  );
}

export default injectSheet(styles)(App);